import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Connect from '../select/Connect';
import useTranslation from '../../hooks/useTranslation';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0;
`

const Label = styled.span`
    font-size: var(--font-S);
    color: ${({ theme }) => theme.font.label};
    white-space: nowrap;
`

const ControlWrapper = styled.div`
    width: 260px;
`

const STORAGE_KEY_PREFIX = 'connectFilter';

const ConnectFilter = ({ config, listType, onFilterChange }) => {
    const { t } = useTranslation();
    const storageKey = `${STORAGE_KEY_PREFIX}:${listType}`;

    const idField = config.filterField;
    const nameField = config.filterField.replace(/Id$/, 'Name');
    const valueMap = { [idField]: 'id', [nameField]: 'name' };

    const [values, setValues] = useState({ [idField]: '', [nameField]: '' });

    useEffect(() => {
        const stored = localStorage.getItem(storageKey);
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                setValues(parsed);
                if (parsed[idField]) {
                    onFilterChange({ field: idField, value: parsed[idField] });
                }
            } catch {}
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSetValue = (changes) => {
        const updated = { ...values };
        for (const { target } of changes) {
            updated[target.name] = target.value;
        }
        setValues(updated);
        if (updated[idField]) {
            localStorage.setItem(storageKey, JSON.stringify(updated));
            onFilterChange({ field: idField, value: updated[idField] });
        } else {
            localStorage.removeItem(storageKey);
            onFilterChange(null);
        }
    };

    return (
        <Wrapper>
            <Label>{t(config.label)}:</Label>
            <ControlWrapper>
                <Connect
                    entity={config.entity}
                    id={idField}
                    name={idField}
                    mainValueId={values[idField]}
                    valueName={values[nameField]}
                    valueMap={valueMap}
                    setValue={handleSetValue}
                    placeholder={t(config.placeholder)}
                    modalTitle={t(config.label)}
                    options={{ withHeaders: false }}
                    menuItemField={config.menuItemField ?? 'name'}
                    listDisplay={config.listDisplay}
                    $marginBottom="0"
                />
            </ControlWrapper>
        </Wrapper>
    );
};

export default ConnectFilter;
